import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NotificationPriority, NotificationType, useGetUnreadCount } from "@/lib/api/user_notification";
import NotificationsList from "./List";

export default function NotificationsSection() {
  const [activeFilters, setActiveFilters] = useState({
    priorities: [] as number[],
    types: [] as string[],
    groups: [] as string[],
    filter_to: [] as ("UNREAD")[],
  });

  const togglePriorityFilter = (priority: number) => {
    setActiveFilters(prev => ({
      ...prev,
      priorities: prev.priorities.includes(priority)
        ? prev.priorities.filter(p => p !== priority)
        : [...prev.priorities, priority]
    }));
  };

  const toggleTypeFilter = (type: string) => {
    setActiveFilters(prev => ({
      ...prev,
      types: prev.types.includes(type)
        ? prev.types.filter(t => t !== type)
        : [...prev.types, type]
    }));
  };

  const toggleUnreadFilter = () => {
    setActiveFilters(prev => ({
      ...prev,
      filter_to: prev.filter_to.includes("UNREAD") ? [] : ["UNREAD"]
    }));
  };

  const clearAllFilters = () => {
    setActiveFilters({
      priorities: [],
      types: [],
      groups: [],
      filter_to: [],
    });
  };

  return (
    <div className="p-6 space-y-6">
      <Tabs defaultValue="latest" className="w-full">
        <TabsList defaultValue={"unread"} className="grid w-full grid-cols-4">
          <TabsTrigger value="latest">Latest</TabsTrigger>
          <TabsTrigger value="unread">Unread</TabsTrigger>
          <TabsTrigger value="urgent">Urgent</TabsTrigger>
        </TabsList>

        <TabsContent value="latest" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle className="sr-only">Latest Notifications</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <NotificationsList
                page={1}
                pageSize={15}
                priorities={activeFilters.priorities.length > 0 ? activeFilters.priorities : undefined}
                types={activeFilters.types.length > 0 ? activeFilters.types : undefined}
                groups={activeFilters.groups.length > 0 ? activeFilters.groups : undefined}
                filter_to={activeFilters.filter_to.length > 0 ? activeFilters.filter_to : undefined}
              />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="unread" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle className="sr-only">Unread</CardTitle>
            </CardHeader>
            <CardContent>
              <NotificationsList
                page={1}
                pageSize={15}
                priorities={activeFilters.priorities.length > 0 ? activeFilters.priorities : undefined}
                types={activeFilters.types.length > 0 ? activeFilters.types : undefined}
                groups={activeFilters.groups.length > 0 ? activeFilters.groups : undefined}
                filter_to={["UNREAD"]}
              />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="urgent" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle className="sr-only">Urgent</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div>
                <NotificationsList
                  page={1}
                  pageSize={15}
                  priorities={[NotificationPriority.Urgent]}
                  types={activeFilters.types.length > 0 ? activeFilters.types : undefined}
                  groups={activeFilters.groups.length > 0 ? activeFilters.groups : undefined}
                  filter_to={activeFilters.filter_to.length > 0 ? activeFilters.filter_to : undefined}
                />
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
